module.exports = __webpack_public_path__ + "images/1190a19ce3cc940741a60137a1e074cb.svg";